import Grid from "@mui/material/Grid2";
import BaseInput from "components/shared/baseForm/BaseInput";
import React from "react";
import { useFormContext } from "react-hook-form";
import { REQUIRED_ERROR } from "utils/errorMessages";

export default function MarketplaceOtherOrder() {
  const { control, formState: { errors } } = useFormContext();

  return (
    <Grid container spacing={2}  mt={2} justifyContent="center">
      <Grid size={{ xs: 8 }}>
        <BaseInput
          id="guestName"
          control={control}
          errors={errors}
          name="guestName"
          type="text"
          placeholder="Enter Name"
          validationProps={{
            required: REQUIRED_ERROR("Name"),
            maxLength: { value: 50, message: "Name cannot be over 50 characters" },
          }}
          fullWidth
          variant="outlined"
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
        />
      </Grid>
    </Grid>
  );
}
